import { SUPPORTED_LOCALES } from '@headless-workspace/config';
import { DeliveryMethod } from '@headless-workspace/typings';
import { VipBrandsValue } from '../config';
import { BasketProductValue, mapBasketProduct } from './BasketProductValue';
import { CustomerBasketDTO } from './CustomerBasketDTO';

export type CustomerBasketValue = Readonly<{
    id: string;
    productsCount: number;
    samplesCount: number;
    totalBeforeDiscount?: number;
    shippingTotal?: number;
    currency: string;
    total?: number;
    totalDiscount?: number;
    vatPrice?: number;
    products: BasketProductValue[];
    shipments?: {
        shippingOptions: DeliveryMethod;
        priceOfShipment?: number;
    };
}>;

const CZ_VAT = 21;

export const getSpecificCountryPrices = (dto: CustomerBasketDTO, locale: string) => {
    if (locale === SUPPORTED_LOCALES.cs_CZ && dto.total) {
        const vatPrice = (dto.total * CZ_VAT) / (100 + CZ_VAT);
        return {
            vatPrice,
        };
    }
};

const groupIdMapping = (groupId?: string): DeliveryMethod => {
    switch (groupId) {
        case 'collectionpoint_hd':
        case 'collectionpoint':
            return DeliveryMethod.collectionpoint;
        case 'homedelivery':
            return DeliveryMethod.homedelivery;
        case 'clickandcollect':
            return DeliveryMethod.clickandcollect;
        case 'shiptostore':
            return DeliveryMethod.shiptostore;
        default:
            throw new Error(`Unknown delivery method groupId: ${groupId}`);
    }
};

export const mapCustomerBasket = (
    dto: CustomerBasketDTO,
    vipBrands: VipBrandsValue,
    locale: string,
): CustomerBasketValue => {
    return {
        id: dto.id,
        productsCount: dto.productsCount,
        samplesCount: dto.samplesCount,
        totalBeforeDiscount: dto.totalBeforeDiscount,
        shippingTotal: dto.shippingTotal,
        currency: dto.currency,
        total: dto.total,
        totalDiscount: dto.totalDiscount,
        products: dto.products.map((product) => mapBasketProduct(product, dto.currency, vipBrands)),
        shipments:
            dto.shipments && dto.shipments.length > 0
                ? {
                      shippingOptions: groupIdMapping(dto.shipments[0].shippingMethod?.groupId),
                      priceOfShipment: dto.shipments[0].shippingMethod?.price,
                  }
                : undefined,
        ...getSpecificCountryPrices(dto, locale),
    };
};
